import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import LatePaymentsReport from "./LatePaymentsReport";

const LatePaymentsFilter = ({
  daysOverdueRange,
  setDaysOverdueRange,
  colors,
  payments = [],
  companyInfo = {
    name: "Your Company Name",
    address: "123, Avenue Mohammed V, Casablanca",
    phone: "+212 5XX-XXXXXX",
    email: "contact@company.com",
  },
}) => {
  const handleDaysOverdueChange = (field, value) => {
    setDaysOverdueRange((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const overdueRangePresets = [
    { label: "Tous", value: "all" },
    { label: "1-30 jours", value: "30" },
    { label: "31-60 jours", value: "60" },
    { label: "61-90 jours", value: "90" },
    { label: "Plus de 90 jours", value: "90+" },
    { label: "Personnalisé", value: "custom" },
  ];

  return (
    <Card sx={{ mb: 2, bgcolor: colors.primary[900] }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ color: colors.grey[100] }}>
            Filtre par Jours de Retard
          </Typography>

          <LatePaymentsReport
            payments={payments}
            filterInfo={{ daysOverdueRange }}
            companyInfo={companyInfo}
          />
        </Box>

        <Divider sx={{ mb: 3, borderColor: colors.grey[700] }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: colors.grey[100] }}>
                Jours de Retard
              </InputLabel>
              <Select
                value={daysOverdueRange.preset}
                onChange={(e) =>
                  handleDaysOverdueChange("preset", e.target.value)
                }
                label="Jours de Retard"
                sx={{
                  bgcolor: colors.primary[900],
                  color: colors.grey[100],
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: colors.grey[100],
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: colors.grey[100],
                  },
                }}
              >
                {overdueRangePresets.map((preset) => (
                  <MenuItem key={preset.value} value={preset.value}>
                    {preset.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {daysOverdueRange.preset === "custom" && (
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  type="number"
                  label="Minimum jours"
                  value={daysOverdueRange.min}
                  onChange={(e) =>
                    handleDaysOverdueChange("min", e.target.value)
                  }
                  fullWidth
                  sx={{
                    bgcolor: colors.primary[900],
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: colors.grey[100],
                      },
                      "&:hover fieldset": {
                        borderColor: colors.grey[100],
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: colors.grey[100],
                    },
                    "& .MuiInputBase-input": {
                      color: colors.grey[100],
                    },
                  }}
                />
                <TextField
                  type="number"
                  label="Maximum jours"
                  value={daysOverdueRange.max}
                  onChange={(e) =>
                    handleDaysOverdueChange("max", e.target.value)
                  }
                  fullWidth
                  sx={{
                    bgcolor: colors.primary[900],
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: colors.grey[100],
                      },
                      "&:hover fieldset": {
                        borderColor: colors.grey[100],
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: colors.grey[100],
                    },
                    "& .MuiInputBase-input": {
                      color: colors.grey[100],
                    },
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LatePaymentsFilter;
